import axios from "axios";

export default {
  async getFile(url) {
    return await axios({
      method: 'GET',
      url: url,
      baseURL: null,
      responseType: 'blob'
    })
      .then(response => {
        const blob = new Blob([response.data], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });

        return {
          success: true,
          blob
        };
      })
      .catch((error) => {
        return Promise.reject(error.response);
      })
  },
  async getFileStream(url) {
    return await axios({
      method: 'GET',
      url: url,
      baseURL: null,
      responseType: 'stream'
    })
      .then(response => {
        return response;
      })
      .catch((error) => {
        return Promise.reject(error.response);
      })
  },
  async sendFile(endpoint, data, progressFunc) {
    const progressConfig = {
      onUploadProgress: progressFunc ?? (() => {})
    };

    return await axios.post(endpoint, data, progressConfig)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  }
}
